import AppManagerClient from '../../api/AppManagerClient';
import { IManagingScheduledTasksInstance } from '../../api/models';
import { useEffect, useState } from 'react';
import { ScheduledTasksServerManagementView } from './ScheduledTasksServerManagementView';
import { Stack } from 'react-bootstrap';
import { ScheduledTasksEnvironmentComparison } from '../Comparison/ScheduledTasksEnvironmentComparison';
import { AccordionWrapper } from '../UIExtentions/Accordion';

export const ScheduledTasksServerManagement = (props: any) => {
    const [serverApps, setServerApps] = useState(Array<IManagingScheduledTasksInstance>()); //probably goes undefined here
    const [isLoading, setLoadingStatus] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');
    const applicationName = props.applicationName;

    const getServers = async (appName: string) => {
        try {
            const serversResult = await AppManagerClient.getScheduledTasksForManaging(appName);
            setServerApps(serversResult);
        } catch (err: any) {
            setErrorMessage(err.message);
        } finally {
            setLoadingStatus(false);
        }
    };

    useEffect(() => {
        getServers(applicationName);
    }, [applicationName]);

    return (
        <Stack gap={3}>
            <AccordionWrapper
                fitToSize={true}
                headerIcon="fa-code-compare"
                headerText="Environment Comparison"
                objectName={applicationName}
                isLoading={props.isLoading}
                errorMessage={props.errorMessage}
            >
                <ScheduledTasksEnvironmentComparison data={serverApps} />
            </AccordionWrapper>

            <ScheduledTasksServerManagementView
                serverApps={serverApps}
                userPrincipal={props.userPrincipal}
                isLoading={isLoading}
                errorMessage={errorMessage}
                isDataNotFound={serverApps.length === 0}
                applicationName={applicationName}
            />
        </Stack>
    );
};
